import { Component, Input, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { FeatureOf, FEATURES } from '@ceres/feature-toggles';
import { AppUserService } from '@ceres/shared/services';
import { rolePermissions } from '@ceres/domain';
import { CeresFeaturesConfig } from '@ceres/shared/features';

@Component({
    selector: 'ceres-inline-navbar',
    templateUrl: './inline-navbar.component.html',
    styleUrls: ['./inline-navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InlineNavbarComponent {
    readonly features = inject<FeatureOf<CeresFeaturesConfig>>(FEATURES);
    readonly appUserService = inject(AppUserService);

    public permission = rolePermissions;

    @Input() navigationModule: string;
    @Input() currentRoute?: string;
}
